<template>
  <div v-if="loading" class="preview-multi-select">
    <b>{{ $i18n('interface.novo_filtro.nfe_terceiro') }}:</b>
    <span>{{ $i18n('interface.novo_filtro.selecione') }}</span>
  </div>
  <Select
    v-else
    :items="compras"
    :selectedItem="selectedItem"
    :label="$i18n('interface.novo_filtro.nfe_terceiro')"
    :searchPlaceholder="$i18n('interface.novo_filtro.buscar_nfe_terceiro')"
    :filtro_id="filtro.filtro"
    :id="filtro.filtro"
    :path="path"
    @atualizar="onAtualizar"
  />
</template>
<script>
import { ref, toRef, onMounted, getCurrentInstance } from 'vue';
import Select from '../../components/Select.vue';
import { useFiltroSelect } from '../../composables/useFiltroSelect';

export default {
  components: { Select },
  props: {
    filtro: { type: Object, required: true },
    path: { type: String, required: true },
  },
  setup(props) {
    const { proxy } = getCurrentInstance();
    const compras = ref([]);
    const loading = ref(true);

    const { selectedItem, onAtualizar } = useFiltroSelect({
      filtro: toRef(props, 'filtro'),
      path: toRef(props, 'path'),
      items: compras,
    });

    onMounted(() => {
      proxy.$api.get('/compras/busca_selectized')
        .then(response => {
          compras.value = response.data.map(compra => ({
            id: String(compra.id),
            name: compra.label,
          }));
        })
        .catch(error => {
          console.error('Erro ao buscar NF-es de terceiros:', error);
        })
        .finally(() => {
          loading.value = false;
        });
    });

    return { compras, loading, selectedItem, onAtualizar };
  },
}
</script>
